export default {
  methods: {
    exportPdfForSale (id) {
      window.open(`https://agentbkk.com/agentapi/export/pdf/project/sale/${id}`, '_blank')
    },

    exportPdfForCustomer (id) {
      window.open(`https://agentbkk.com/agentapi/export/pdf/project/customer/${id}`, '_blank')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/exportPdf.js